export const ALL_TRAFFIC = {
  name: 'Filters',
  rule: [],
  rule_text: '(Filters)',
};

export const LIVE_TRAFFIC = {
  name: 'Live Traffic',
  rule: [
    [
      {
        field: 'LIVE_VIDEO',
        value: 'T',
        display: 'Live Traffic',
        key: null,
        op: 'eq',
      },
    ],
  ],
  rule_text: '(Content Category EQUALS Live)',
};

export const VOD_TRAFFIC = {
  name: 'VOD Traffic',
  rule: [
    [
      {
        field: 'LIVE_VIDEO',
        value: 'F',
        display: 'VOD Traffic',
        key: null,
        op: 'eq',
      },
    ],
  ],
  rule_text: '(Content Category EQUALS VoD)',
};
